var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlovakia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 10.5322 23.736 9.12605 23.2536 7.82611H0.746391C0.264047 9.12605 0 10.5322 0 12C0 18.6274 5.37262 24 12 24Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C17.1596 24 21.5581 20.7435 23.2536 16.1739H0.746399C2.44191 20.7435 6.84043 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10303 6.78262V12.7688C3.10303 16.174 7.55151 17.2174 7.55151 17.2174C7.55151 17.2174 11.9999 16.174 11.9999 12.7688V6.78262H3.10303Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14655 6.78262V12.7688C4.14655 13.1686 4.23533 13.5461 4.4112 13.9001H10.6918C10.8677 13.5462 10.9565 13.1686 10.9565 12.7688V6.78262H4.14655Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63843 10.9565H8.07327V9.91303H9.11676V8.86955H8.07327V7.82611H7.02979V8.86955H5.98635V9.91303H7.02979V10.9565H5.46454V12H7.02979V13.0435H8.07327V12H9.63843V10.9565Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83458 15.3567C6.507 15.7793 7.19785 16.0246 7.55152 16.1338C7.90519 16.0247 8.59604 15.7793 9.26846 15.3567C9.94655 14.9305 10.4219 14.4431 10.6918 13.9001C10.3941 13.6895 10.0309 13.5652 9.63849 13.5652C9.49561 13.5652 9.35682 13.5822 9.22336 13.6132C8.94057 12.9707 8.29861 12.5218 7.55157 12.5218C6.80452 12.5218 6.16252 12.9707 5.87977 13.6132C5.74632 13.5822 5.60747 13.5652 5.46464 13.5652C5.07225 13.5652 4.70902 13.6895 4.41132 13.9001C4.68108 14.4431 5.15644 14.9305 5.83458 15.3567Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovakia);
export default __webpack_public_path__ + "static/media/slovakia.ccbae2bcad3deb4c2d233cff8b90d17b.svg";
export { ForwardRef as ReactComponent };